import KSlider from "./KSlider.vue";
export default KSlider;
